import React from 'react';
import { connect } from 'react-redux';
import { formValueSelector } from 'redux-form';
import { withPropsOnChange, compose } from 'recompose';
import _ from 'lodash';
import { MenuItem, LinearProgress } from 'material-ui';
import ErrorIcon from 'material-ui/svg-icons/alert/error';
import AddIcon from 'material-ui/svg-icons/content/add';
import RemoveIcon from 'material-ui/svg-icons/content/remove';
import humanize from 'humanize-string';
import { CAMPAIGN_FORM_ID, WIZZARD_FORM_ID, LANGUAGES } from 'dash-front/constants';
import { fetchMessages } from 'dash-front/messages/actions';
import { responseStatusIsOk } from 'dash-front/helpers';

const templateExists = template => [null, undefined].every(v => v !== template);

const LANG_MAP = LANGUAGES.reduce((acc, cur) => {
    acc[cur.key] = cur.name;
    return acc;
}, {});
const MessageTemplate = connect((state, { id }) => ({
    message: _.get(state.requery.entities, ['messageTemplates', id]),
    language: formValueSelector(CAMPAIGN_FORM_ID)(state, 'language') || 'en'
}))(({ message, id, onClick, language, leftIcon }) => {
    const template = _.get(message, ['template', language]);
    const beautyLanguage = LANG_MAP[language] || language;
    return (
        <MenuItem onTouchTap={onClick} leftIcon={leftIcon} style={{ overflow: 'hidden' }}>
            {message ? (
                <div>
                    <div>{message.title}</div>
                    <small style={{ textOverflow: 'ellipsis' }}>
                        {templateExists(template) ? template : `No template for ${beautyLanguage} language`}
                    </small>
                </div>
            ) : (
                <div>Deleted or not existing message #{id}</div>
            )}
        </MenuItem>
    );
});

const MessageTemplateArray = compose(
    connect(
        state => ({
            ids: state.requery.list['messageTemplates'],
            entities: state.requery.entities['messageTemplates'],
            isPending: _.get(state.requery.queries['GET:messageTemplates'], 'isPending'),
            reqStatus: _.get(state.requery.queries['GET:messageTemplates'], 'status'),
            trigger: formValueSelector(WIZZARD_FORM_ID)(state, 'triggerType')
        }),
        dispatch => ({ fetchMessages: () => dispatch(fetchMessages()) })
    ),
    withPropsOnChange(
        (cur, next) =>
            Array.isArray(next.ids) &&
            (next.ids !== cur.ids || cur.trigger !== next.triggers || cur.entities !== next.entities),
        props => {
            const ids = Array.isArray(props.ids) ? props.ids : [];
            return {
                ids: ids.filter(id => _.get(props.entities, [id, 'trigger']) === props.trigger)
            };
        }
    )
)(
    class _MessageTemplateArray extends React.PureComponent {
        componentDidMount() {
            this.props.fetchMessages();
        }

        onItemClick = (id, valueIndex) => {
            const isPresent = typeof valueIndex === 'number';
            if (isPresent) {
                this.props.fields.remove(valueIndex);
            } else {
                this.props.fields.push(id);
            }
        };

        renderItems() {
            const { ids, fields, reqStatus, trigger } = this.props;
            if (!Array.isArray(ids) || !responseStatusIsOk(reqStatus)) {
                return (
                    <div style={{ display: 'flex', alignItems: 'center' }}>
                        <ErrorIcon />
                        <span style={{ marginLeft: 12 }}>Error while fetching messages</span>
                    </div>
                );
            }
            if (!trigger) {
                return <div>No trigger selected</div>;
            }
            if (!ids.length) {
                return <div>No message templates for trigger type: {humanize(trigger)}</div>;
            }
            const allValues = fields.getAll();
            const valArr = Array.isArray(allValues) ? allValues : [];
            const notSelectedIds = _.difference(ids, valArr);
            return (
                <div>
                    Message templates
                    <div style={{ display: 'flex' }}>
                        <div style={{ width: '400px', overflow: 'hidden' }}>
                            {valArr.map((id, index) => (
                                <MessageTemplate
                                    key={id}
                                    id={id}
                                    leftIcon={<RemoveIcon />}
                                    onClick={() => this.onItemClick(id, index)}
                                />
                            ))}
                        </div>
                        <div style={{ width: '400px', overflow: 'hidden' }}>
                            {notSelectedIds.map(id => (
                                <MessageTemplate
                                    key={id}
                                    id={id}
                                    leftIcon={<AddIcon />}
                                    onClick={() => this.onItemClick(id)}
                                />
                            ))}
                        </div>
                    </div>
                </div>
            );
        }

        render() {
            const { isPending } = this.props;
            return (
                <div>
                    {isPending ? (
                        <div>
                            Loading message templates
                            <LinearProgress />
                        </div>
                    ) : (
                        this.renderItems()
                    )}
                </div>
            );
        }
    }
);

export default MessageTemplateArray;



/** WEBPACK FOOTER **
 ** ../src/dash/front/campaign/containers/Campaign/MessageTemplateArray.js
 **/